export const TRANSITION_NAME = {
  FADE: 'sf-fade',
  SECTION: 'section-transition',
  COLLAPSE_BOTTOM: 'sf-collapse-bottom',
  COLLAPSE_TOP: 'sf-collapse-top',
  SLIDE_LEFT: 'sf-slide-left',
  SLIDE_RIGHT: 'sf-slide-right',
  EXPAND: 'sf-expand',
} as const;
